import React, {Component} from 'react';
import AuthenticationService from "../../services/AuthenticationService";
import Constants from "../../configs/Constants";
import {genSso} from "../../common/Utils";
import queryString from 'query-string';
import {Cookies} from "react-cookie";
import {ACTIONS} from "../Login/reducers";
import {connect} from 'react-redux';
import moment from 'moment';
import {LocalStorage} from "../../common/StorageUtil";

const cookie = new Cookies();

class Sso extends Component {

    constructor(props) {
        super(props);
        this.service = new AuthenticationService();
    }

    componentWillMount() {
        if (!this.checkLogged() && window.globalConfig.LOGIN_SSO) {
            let location = this.props.location;
            let params = queryString.parse(location.search);
            if (params.code) {
                this.beforeLogin(params.code);
            } else {
                window.location.replace(genSso(window.location.href));
            }
        }
    };

    beforeLogin = async (code) => {
        let result = await this.service.getTokenByCode(code);
        if (result.code == Constants.RESPONSE_STATUS.API_000) {
            this.saveLocal(JSON.parse(result.data.data))
        }
    };

    saveLocal(data) {

        LocalStorage.setItem(Constants.STORAGE_KEY.ADMIN_USER, data.username);
        cookie.set(Constants.STORAGE_KEY.TOKEN_LOGGED, data.tokenData.accessToken, {
            path: (process.env.PUBLIC_URL === undefined || process.env.PUBLIC_URL === null || process.env.PUBLIC_URL === "") ? "/" : process.env.PUBLIC_URL,
            expires: moment(new Date()).add(24 * 60 * 60 * 1000, 'ms').toDate()
        });
        window.open(`${process.env.PUBLIC_URL}/`, "_self");
    };

    checkLogged = () => {
        let tokenLogged = cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED);
        if (tokenLogged === undefined || tokenLogged === "" || tokenLogged === null) {
            return false;
        }
        return true;
    };

    render() {
        return (
            <div></div>
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    LoginReducer: (userInfo) => dispatch({
        type: ACTIONS.UPDATE_USER_INFO,
        payload: userInfo
    }),
});

export default (connect(mapStateToProps, mapDispatchToProps)(Sso));
